// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { XAccountStateType } from "@steiner/App/Store/Reducers";

type HandlerType = Handler<
    XAccountStateType,
    {
        isCustomFieldsValid?: boolean;
    }
>;

export const ValidateFields: HandlerType = props => {
    const {
        parameter: { isCustomFieldsValid },
    } = props;
    props.isCustomFieldsValid = isCustomFieldsValid;
};

export const XDispatchUpdateAccountSettings: HandlerType = props => {
    props.dispatch({
        type: "xAccountSettings/Update" as any,
        ...props.parameter,
    });
};

export const chain = [ValidateFields, XDispatchUpdateAccountSettings];

const xUpdateAccountSettings = createHandlerChainRunner(chain, "xUpdateAccountSettings");
export default xUpdateAccountSettings;
